import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {OptTaskDetails} from '../../../classes/models/admin/OptTaskDetails';
import {OptimisationTaskService} from '../../../services/http/admin/optimisation-task.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

@Component({
  selector: 'app-admin-optimisation-tasks',
  templateUrl: './admin-optimisation-tasks.component.html',
  styleUrls: ['./admin-optimisation-tasks.component.less'],
  imports: [SHARED_IMPORTS]
})
export class AdminOptimisationTasksComponent implements OnInit {
  private optimisationTaskService = inject(OptimisationTaskService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** A list of details of all optimisation tasks. */
  optTasksDetails: OptTaskDetails[];
  /** Search text by which optimisation details should be filtered. */
  searchText: string;

  ngOnInit(): void {
    this.updateOptTasksDetails();
  }

  /**
   * Retrieves a list of optimisation task details from backend.
   */
  updateOptTasksDetails() {
    this.optimisationTaskService.getOptTasksDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: res => this.optTasksDetails = res
            });
  }

  /**
   * Enables optimisation task for the given store and then retrieves updated task details from backend.
   * @param storeId an identifier of a store.
   */
  enableOptTask(storeId: string) {
    this.optimisationTaskService.enableOptTask(storeId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }

  /**
   * Enables optimisation tasks for all stores and then retrieves updated task details from backend.
   */
  enableAllOptTasks() {
    this.optimisationTaskService.enableAllOptTasks()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }

  /**
   * Disables optimisation task for the given store and then retrieves updated task details from backend.
   * @param storeId an identifier of a store.
   */
  disableOptTask(storeId: string) {
    this.optimisationTaskService.disableOptTask(storeId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }

  /**
   * Disables optimisation tasks for all stores and then retrieves updated task details from backend.
   */
  disableAllOptTasks() {
    this.optimisationTaskService.disableAllOptTask()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }

  /**
   * Resets all optimisation tasks and then retrieves updated task details from backend.
   */
  resetAllOptTasks() {
    this.optimisationTaskService.resetAllOptTasks()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }

  /**
   * Resets optimisation task for the given store and then retrieves updated task details from backend.
   * @param storeId an identifier of a store.
   */
  resetOptTask(storeId: string) {
    this.optimisationTaskService.resetOptTask(storeId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateOptTasksDetails()
            });
  }
}
